import React from 'react';
import { CloseOutlined, MinusOutlined, PlusOutlined, ShoppingOutlined } from '@ant-design/icons';
import type { CarritoItem } from '../../../store/Carrito/types';
import styles from './Carrito.module.scss';

interface CarritoDropdownProps {
  items: CarritoItem[];
  onClose: () => void;
  onRemove: (productoId: string) => void;
  onUpdateCantidad: (productoId: string, cantidad: number) => void;
  onReservar: () => void;
}

export const CarritoDropdown: React.FC<CarritoDropdownProps> = ({
  items,
  onClose,
  onRemove,
  onUpdateCantidad,
  onReservar,
}) => {
  const total = items.reduce((sum, item) => sum + item.precio * item.cantidad, 0);

  return (
    <div className={styles.carrito}>
      <div className={styles.carrito__header}>
        <h3 className={styles.carrito__title}>Mi carrito</h3>
        <button className={styles.carrito__close} onClick={onClose}>
          <CloseOutlined />
        </button>
      </div>

      {items.length === 0 ? (
        <div className={styles.carrito__empty}>
          <ShoppingOutlined className={styles.carrito__emptyIcon} />
          <p>Tu carrito está vacío</p>
        </div>
      ) : (
        <>
          <div className={styles.carrito__list}>
            {items.map(item => (
              <div key={item.productoId} className={styles.carrito__item}>
                <div className={styles.carrito__itemImage}>
                  {item.imagen ? (
                    <img src={item.imagen} alt={item.nombre} loading="lazy" />
                  ) : (
                    <div className={styles.carrito__itemNoImage} />
                  )}
                </div>

                <div className={styles.carrito__itemInfo}>
                  <p className={styles.carrito__itemName}>{item.nombre}</p>
                  <p className={styles.carrito__itemPrice}>${item.precio.toFixed(2)}</p>

                  <div className={styles.carrito__stepper}>
                    <button
                      onClick={() => onUpdateCantidad(item.productoId, item.cantidad - 1)}
                      disabled={item.cantidad <= 1}
                    >
                      <MinusOutlined />
                    </button>
                    <span>{item.cantidad}</span>
                    <button
                      onClick={() => onUpdateCantidad(item.productoId, item.cantidad + 1)}
                      disabled={item.cantidad >= item.stockDisponible}
                    >
                      <PlusOutlined />
                    </button>
                  </div>
                </div>

                <button className={styles.carrito__removeBtn} onClick={() => onRemove(item.productoId)}>
                  <CloseOutlined />
                </button>
              </div>
            ))}
          </div>

          <div className={styles.carrito__footer}>
            <div className={styles.carrito__total}>
              <span>Total</span>
              <span>${total.toFixed(2)}</span>
            </div>
            <button className={styles.carrito__reservarBtn} onClick={onReservar}>
              Reservar productos
            </button>
          </div>
        </>
      )}
    </div>
  );
};
